import { api } from './client'

const BASE = (import.meta.env.VITE_API_BASE_URL || '') + '/api/v1'

export const protocolsApi = {
  list: (token) => api.get('/protocols', token),
  detail: (protocolId, token) => api.get(`/protocols/${protocolId}`, token),

  // Same shape as ``detail`` but with today's variable steps
  // interleaved between the fixed ones — see app/api/protocols.py
  // ``get_protocol_today``. ``date`` is the user's local YYYY-MM-DD;
  // we pass it explicitly so the server buckets against the user's
  // calendar day rather than UTC.
  today: (protocolId, date, token) => {
    const path = `/protocols/${protocolId}/today` + (date ? `?target_date=${date}` : "");
    return api.get(path, token);
  },
  complete: (payload, token) => api.post('/protocols/complete', payload, token),
  reflection: (payload, token) => api.post('/protocols/complete/reflection', payload, token),

  // Mood-tap pill on the protocol completion screen. ``affect`` must be
  // one of {settled, strong, neutral, heavy}; the server enforces the
  // same Literal at the schema layer. Idempotent, so a re-tap silently
  // overwrites.
  setAffect: (completionId, affect, token) =>
    api.patch(`/protocols/complete/${encodeURIComponent(completionId)}/affect`, { affect }, token),

  uncomplete: async (payload, token) => {
    // DELETE with JSON body — api.delete doesn't accept a body
    const headers = { 'Content-Type': 'application/json' }
    if (token) headers['Authorization'] = `Bearer ${token}`
    const res = await fetch(`${BASE}/protocols/complete`, {
      method: 'DELETE',
      headers,
      body: JSON.stringify(payload),
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: res.statusText }))
      throw Object.assign(new Error(err.detail || 'Request failed'), { status: res.status })
    }
    return res.json()
  },

  completions: (protocolId, date, token) => {
    let path = `/protocols/completions?protocol_id=${encodeURIComponent(protocolId)}`
    if (date) path += `&target_date=${date}`
    return api.get(path, token)
  },

  // Fetch the protocol-level reflection (textarea at the bottom of the
  // flow) for a given date. Returns the row when present, or rejects
  // with ``status: 404`` when the user hasn't reflected yet. Caller
  // uses the 404 to distinguish "show the submit UI" from "lock in the
  // saved text" on mount.
  getReflection: async (protocolId, date, token) => {
    let path = `/protocols/reflection?protocol_id=${encodeURIComponent(protocolId)}`
    if (date) path += `&target_date=${date}`
    return api.get(path, token)
  },

  streak: (protocolId, token) =>
    api.get(`/protocols/streak?protocol_id=${encodeURIComponent(protocolId)}`, token),

  // Real BEH-domain Key Signals (Morning Anchor / Evening Protocol /
  // Habit Adherence / Anchor Streak) for the DomainDetail screen,
  // computed server-side from protocol_completions. ``date`` is the
  // user's local YYYY-MM-DD so the 7-day windows bucket against their
  // calendar day, not UTC.
  behMetrics: (date, token) => {
    const path = '/protocols/beh-metrics' + (date ? `?target_date=${date}` : '')
    return api.get(path, token)
  },
}
